import type { SurveyData } from "../../types";

export function handleRadioChange(
	id: string,
	name: string,
	setForm: React.Dispatch<React.SetStateAction<SurveyData>>,
) {
	setForm((prev) => ({
		...prev,
		[name]: id,
	}));
}
